import * as React from 'react';
import * as deepmerge from 'deepmerge';
import { baseStyles } from './baseStyles';
import { styles as oemStyles } from './oem/styles';

type Styles = typeof baseStyles;

const currentStyle: Styles = deepmerge(baseStyles, oemStyles);

export type OemProps = {
    styles: { [name: string]: React.CSSProperties };
};

//
// skin() is a higher-order component that injects the current OEM styles into 
// the wrapped component.
//
export function skin<T extends OemProps>(Target: React.ComponentType<T>) {
    return class extends React.Component<T, {}> {
        static displayName = `skin(${Target.displayName || Target.name || '?'})`;

        constructor(props: T) {
            super(props);
        }

        render() {
            return (
               <Target { ...this.props } styles={ currentStyle }/>
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/styles/skin.tsx